// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// Components
import OMCheckbox from '../OMComponents/OMCheckbox/OMCheckbox';
// Containers
import MultiselectWrapper from '../../containers/OMContainers/MultiselectWrapper/MultiselectWrapper';
import { commoditiesOptions, additionsOptions } from '../../containers/PublishForm/PublishPropertyFormConstants';
// Constants
import { bathToiletsOptions, optionTypes } from '../../constants';
// Helpers
import { bathToiletsTitle } from '../../utils/multiselectsTitles';
// Styles
import * as styles from './AdditionalFilters.scss';

class AdditionalFilters extends Component {
  defaultProps = {
    commodities: []
  };

  createField = id => ({
    value: id,
    checked: this.props.commodities.indexOf(id) !== -1,
    onChange: evt => this.props.onChange(evt.currentTarget.value)
  });

  filterCommodities = (commodities = []) => commodities.filter(({ id }) => {
    if (this.props.location === 'commercial') {
      return (id !== 'stroller_room');
    }

    if (this.props.optionType === optionTypes.buy) {
      return (id !== 'roommates');
    }

    return true;
  });

  render() {
    const { translate, photosField, vrField, bathrooms, toilets } = this.props;
    const translatePublish = translate('publishProperty');
    const bathTitle = bathToiletsTitle(bathrooms || undefined, translate);
    const toiletsTitle = bathToiletsTitle(toilets || undefined, translate);

    const propertyCommodities = this.filterCommodities(commoditiesOptions(translatePublish));

    return (
      <div className={styles.additionalFilterWrapper}>
        <div className={styles.bathToiletsWrapper}>
          <div className={styles.bathToiletsRowWrapper}>
            <div className={styles.titleWrapper}>
              <span className={styles.iconWrapper}><i className="icon-bathroom" /></span>
              <span className={styles.title}>{translate('advancedFilters', 'bath')}</span>
            </div>
            <div className={styles.selectWrapper}>
              <MultiselectWrapper
                options={bathToiletsOptions(translate)}
                title={bathTitle}
                value={bathrooms}
                onChange={value => this.props.onBathToiletsChange('bathrooms', value)}
              />
            </div>
          </div>
          <div className={styles.bathToiletsRowWrapper}>
            <div className={styles.titleWrapper}>
              <span className={styles.iconWrapper}><i className="icon-restroom" /></span>
              <span className={styles.title}>{translate('advancedFilters', 'toilets')}</span>
            </div>
            <div className={styles.selectWrapper}>
              <MultiselectWrapper
                options={bathToiletsOptions(translate)}
                title={toiletsTitle}
                value={toilets}
                onChange={value => this.props.onBathToiletsChange('toilets', value)}
              />
            </div>
          </div>
        </div>
        <div className={styles.commoditiesWrapper}>
          <div className={styles.commodities}>
            {propertyCommodities
              .map(({ id, label }) =>
                (<div key={id}>
                  <OMCheckbox
                    id={id}
                    label={label}
                    field={this.createField(id)}
                  />
                </div>)
              )
            }
          </div>
          <div className={styles.commodities}>
            {this.filterCommodities(additionsOptions(translatePublish))
              .map(({ id, label }) =>
                (<div key={id}><OMCheckbox id={id} label={label} field={this.createField(id)} /></div>)
              )
            }
          </div>
          <div className={cx(styles.commodities, styles.additionalCheckboxes)}>
            <div>
              <OMCheckbox
                id="photos"
                label={translate('advancedFilters', 'photos')}
                field={photosField}
              />
            </div>
            <div>
              <OMCheckbox
                id="vr"
                label={translate('advancedFilters', 'vr')}
                field={vrField}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AdditionalFilters.propTypes = {
  translate: PropTypes.func,
  onChange: PropTypes.func,
  photosField: PropTypes.object,
  vrField: PropTypes.object,
  location: PropTypes.string,
  commodities: PropTypes.array,
  bathrooms: PropTypes.array,
  toilets: PropTypes.array,
  onBathToiletsChange: PropTypes.func,
  optionType: PropTypes.string
};

export default AdditionalFilters;
